/** Contact / support client. Submit is public; the admin inbox needs saas_owner. */
const API = "/api/v1";

export type SupportCategory = "general" | "billing" | "technical" | "sales" | "bug";
export type SupportStatus = "open" | "resolved";

export interface SupportPayload {
  name: string;
  email: string;
  category?: SupportCategory;
  subject?: string;
  message: string;
}

export interface SupportMessage {
  _id: string;
  name: string;
  email: string;
  category: SupportCategory;
  subject?: string;
  message: string;
  status: SupportStatus;
  createdAt: string;
}

const authHeaders = (): Record<string, string> => {
  const token = localStorage.getItem("auth_token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

/** Public — send a contact/support message. Includes the auth token if signed in. */
export async function sendSupportMessage(payload: SupportPayload): Promise<void> {
  const r = await fetch(`${API}/support`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const j = (await r.json()) as { success: boolean; message?: string };
  if (!r.ok || !j.success) throw new Error(j.message || "Could not send your message");
}

/** Admin inbox. */
export async function listSupportMessages(status?: SupportStatus): Promise<SupportMessage[]> {
  const qs = status ? `?status=${status}` : "";
  const r = await fetch(`${API}/support${qs}`, { headers: authHeaders() });
  const j = (await r.json()) as { success: boolean; data: SupportMessage[] };
  if (!r.ok || !j.success) throw new Error("Could not load messages");
  return j.data;
}

export async function updateSupportMessage(id: string, status: SupportStatus): Promise<void> {
  await fetch(`${API}/support/${id}`, { method: "PATCH", headers: authHeaders(), body: JSON.stringify({ status }) });
}
